import * as THREE from 'three';
import {
    NPC_COUNT,
    DETECTION_RANGE,
    STRATEGY_COOLDOWN,
    NPC_SPEED,
    FIRE_RANGE,
    FIRE_COOLDOWN,
    UPDATE_INTERVAL,
    PATROL_SPEED,
    STRATEGY_REQUEST_COOLDOWN,
    ROTATION_SPEED,
    BROADSIDE_ANGLE,
    NPCState
} from './constants.js';

export class NPCManager {
    constructor(playerBoat) {
        this.playerBoat = playerBoat;
        this.npcShips = new Map();
    }

    update() {
        // NPC updates are now handled by the server
        // This method is kept for backward compatibility
    }

    // Handle server updates for NPCs
    handleNPCUpdate(npcData) {
        const npcBoat = this.npcShips.get(npcData.id);
        if (npcBoat) {
            // Update position and rotation
            npcBoat.position.set(npcData.position.x, npcData.position.y, npcData.position.z);
            npcBoat.rotation.y = npcData.rotation.y;
        }
    }

    // Handle new NPC from server
    handleNewNPC(npcData) {
        if (this.npcShips.has(npcData.id)) return;

        const npcBoat = createBoat(npcData.name);
        npcBoat.userData.id = npcData.id;
        npcBoat.userData.isNPC = true;
        npcBoat.userData.health = npcData.health;
        npcBoat.userData.lastFireTime = 0;

        // Set initial position and rotation
        npcBoat.position.set(npcData.position.x, npcData.position.y, npcData.position.z);
        npcBoat.rotation.y = npcData.rotation.y;

        this.npcShips.set(npcData.id, npcBoat);
        scene.add(npcBoat);
    }

    // Handle NPC health update from server
    handleNPCHealthUpdate(npcId, health) {
        const npcBoat = this.npcShips.get(npcId);
        if (npcBoat) {
            npcBoat.userData.health = health;
            if (health <= 0) {
                this.handleNPCDestruction(npcId);
            }
        }
    }

    // Handle NPC destruction
    handleNPCDestruction(npcId) {
        const npcBoat = this.npcShips.get(npcId);
        if (npcBoat) {
            scene.remove(npcBoat);
            this.npcShips.delete(npcId);
        }
    }

    // Handle NPC hit effect
    handleNPCHit(npcId, hitType, hitPosition) {
        const npcBoat = this.npcShips.get(npcId);
        if (npcBoat) {
            createExplosion(npcBoat.position, hitType, hitPosition);
        }
    }
} 